export const COPY = 'copy';
export const REDIRECT = 'redirect';
